import { render, staticRenderFns } from "./CreateGoalModal.vue?vue&type=template&id=036a175e"
import script from "./CreateGoalModal.vue?vue&type=script&lang=ts"
export * from "./CreateGoalModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateGoalModal.vue?vue&type=style&index=0&id=036a175e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports